import React from 'react';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from '../../i18n/i18n';

function LangGuard() {
    const { lang } = useParams();
    const location = useLocation();

    if (!SUPPORTED_LANGUAGES.includes(lang)) {
        return <Navigate to={`/${DEFAULT_LANGUAGE}${location.pathname}${location.search}`} replace />;
    }

    return <Outlet />;
}

export {
    LangGuard
};
